/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function _filterThumbnails(variant) {
    // console.log('thumbnail updated', variant)
    // if (variant.featured_image != null && variant.featured_image.alt != null) {
        // show thumbnails for selected color
        $('[data-variant]').hide()
        var selected_variant = variant.id
        var thumbnail_selector = `[data-variant="${selected_variant}"]`
        $(thumbnail_selector).show()
        // console.log('thumbnail_selector', $(thumbnail_selector))
        // console.log('showing some', thumbnail_selector)
    // } else {
        // show all thumbnails
        // $('[data-variant]').show()
        // console.log('showing all')
    // }
}

function _updateProductTabs(variant){
    console.log("Update product logs...")
}

document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    try{
        page._filterThumbnails(variant)
    }catch(err){
        console.log('cannot access page variable')
    }
    
    try{
        tryon.applySku(variant.sku)
    }catch(err){
        console.log('Try on not active')
    }

    try{
        window['AstralGlobalAnalytics'].variant = variant
        globalAnalytics.pushEvent({key:'productDetail'}, {label: variant.name}, {value: Number(variant.price / 100).toFixed(2)})
    }catch(err){
        console.log('Cannot set global analytics value')
    }
});

// document.addEventListener('product:changed', function (event) {
    // console.log('product', product)
    // var variant = event.detail.variant; // Gives you access to the whole variant details
    // _filterThumbnails(variant)
// });

